import gql from "graphql-tag";

export const ADD_MESURE = gql`
  mutation addMesure(
    $date_nomination: date!
    $date_protection_en_cours: date!
    $date_premier_mesure: date
    $departement_code: String
    $nature_mesure: nature_mesure_enum!
    $champ_mesure: champ_mesure_enum
    $lieu_vie: lieu_vie_majeur_enum!
    $type_etablissement: type_etablissement_enum
    $code_postal: String
    $ville: String
    $civilite: civilite_enum!
    $annee_naissance: String!
    $numero_dossier: String!
    $numero_rg: String!
    $antenne_id: Int
    $ti_id: Int!
    $latitude: Float
    $longitude: Float
    $pays: String!
    $cabinet: String
    $mandataireId: Int
    $serviceId: Int
  ) {
    reset_mesures_calculations(
      mandataireId: $mandataireId
      serviceId: $serviceId
    ) {
      state
    }
    add_or_update: insert_mesures(
      objects: {
        mandataire_id: $mandataireId
        service_id: $serviceId
        departement_code: $departement_code
        date_nomination: $date_nomination
        date_protection_en_cours: $date_protection_en_cours
        date_premier_mesure: $date_premier_mesure
        nature_mesure: $nature_mesure
        champ_mesure: $champ_mesure
        ti_id: $ti_id
        lieu_vie: $lieu_vie
        code_postal: $code_postal
        ville: $ville
        civilite: $civilite
        annee_naissance: $annee_naissance
        numero_dossier: $numero_dossier
        numero_rg: $numero_rg
        status: en_cours
        antenne_id: $antenne_id
        latitude: $latitude
        longitude: $longitude
        pays: $pays
        cabinet: $cabinet
        mesure_etats: {
          data: [
            {
              date_changement_etat: $date_nomination
              nature_mesure: $nature_mesure
              champ_mesure: $champ_mesure
              lieu_vie: $lieu_vie
              type_etablissement: $type_etablissement
              code_postal: $code_postal
              ville: $ville
              pays: $pays
            }
          ]
        }
      }
    ) {
      returning {
        id
      }
    }
  }
`;
